import { HttpService } from './http.service';
import {
    IApiResponse,
    IPaymentsList,
    ISubscription,
    ISubscriptionRequest,
    ITotalPaid,
    ITypesDocument,
    SubscriptionResponse,
} from '../domain/interfaces/Subscription';

// Servicio para manejar suscripciones de manera segura
export const SubscriptionService = {
    getPayments: async (companyId: string): Promise<IApiResponse<IPaymentsList[]>> => {
        return new Promise<IApiResponse<IPaymentsList[]>>((resolve, reject) => {
            HttpService.get(`/api/payments/charges?companyId=${companyId}`).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

    getSubscription: async (companyId: string): Promise<IApiResponse<ISubscription>> => {
        return new Promise<IApiResponse<ISubscription>>((resolve, reject) => {
            HttpService.get(`/api/payments/subscription-by-company?CompanyId=${companyId}`).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

    createSubscription: async (subscriptionData: ISubscriptionRequest): Promise<IApiResponse<SubscriptionResponse>> => {
        return new Promise<IApiResponse<SubscriptionResponse>>((resolve, reject) => {
            HttpService.post('/api/payments/subscription', subscriptionData).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

    cancelSubscription: async (subscriptionId: string): Promise<IApiResponse<any>> => {
        return new Promise<IApiResponse<any>>((resolve, reject) => {
            HttpService.delete(`/api/payments/${subscriptionId}`).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

    getTypesDocument: async (): Promise<IApiResponse<ITypesDocument>> => {
        return new Promise<IApiResponse<ITypesDocument>>((resolve, reject) => {
            HttpService.get('/api/payments/document-type').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

    getTotalPaid: async (companyId: string): Promise<IApiResponse<ITotalPaid>> => {
        return new Promise<IApiResponse<ITotalPaid>>((resolve, reject) => {
            HttpService.get(`/api/payments/total-paid/${companyId}`).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        })
    },

};

export default SubscriptionService;
